import { makeAutoObservable } from 'mobx'
import { type INormalizedApiError } from 'shared/api'
import { type IResponseRcs } from 'entities/Rcs'

const BRAND_NAME_MAX_LENGTH = 100

export class BrandInfoStore {
  private _brandName = ''
  private _brandNameError = ''
  private _brandDescription = ''
  private _brandDescriptionError = ''

  constructor() {
    makeAutoObservable(this)
  }

  get brandName() {
    return this._brandName
  }

  get brandNameError() {
    return this._brandNameError
  }

  get brandDescription() {
    return this._brandDescription
  }

  get brandDescriptionError() {
    return this._brandDescriptionError
  }

  get brandNameMaxLength() {
    return BRAND_NAME_MAX_LENGTH
  }

  get isBrandNameMaxLengthReached() {
    return this._brandName.length >= this.brandNameMaxLength
  }

  get brandDescriptionMaxLength() {
    return this.brandNameMaxLength
  }

  get isBrandDescriptionMaxLengthReached() {
    return this._brandDescription.length >= this.brandDescriptionMaxLength
  }

  setBrandName = (name: string) => {
    this._brandName = name
    if (this._brandNameError) this._brandNameError = ''
  }

  setBrandDescription = (description: string) => {
    this._brandDescription = description
    if (this._brandDescriptionError) this._brandDescriptionError = ''
  }

  validate = () => {
    let hasError = false

    if (!this._brandName) {
      this._brandNameError = 'Enter a brand name'
      hasError = true
    }

    if (!this._brandDescription) {
      this._brandDescriptionError = 'Enter a brand description'
      hasError = true
    }

    return hasError
  }

  init = (data: IResponseRcs) => {
    this._brandName = data.name || ''
    this._brandDescription = data.description || ''
  }

  initErrors = (errors: INormalizedApiError) => {
    this._brandNameError = errors.getError('name')
    this._brandDescriptionError = errors.getError('description')
  }

  reset = () => {
    this._brandName = ''
    this._brandNameError = ''
    this._brandDescription = ''
    this._brandDescriptionError = ''
  }
}
